<template>
  <div id="FAQCreate">
    <panel
      Title="افزودن پرسش و پاسخ متداول"
      Des="از طریق این فرم می‌توانید پرسش و پاسخ جدید اضافه کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <net-pa-card>
      <template slot="header">
        <h6 class="text-right">
          <i class="fas fa-plus-circle"></i>
          فرم ایجاد پرسش و پاسخ
        </h6>
      </template>
      <template slot="content">
        <form class="faq-create-form" @submit.prevent="createFAQ">
          <div class="faq-create-field">
            <label class="faq-create-label" for="faq-question">سوال</label>
            <textarea
              id="faq-question"
              class="form-control faq-create-input"
              rows="3"
              placeholder="سوال را وارد کنید"
              v-model="question"
            ></textarea>
          </div>
          <div class="faq-create-field">
            <label class="faq-create-label" for="faq-answer">پاسخ</label>
            <textarea
              id="faq-answer"
              class="form-control faq-create-input"
              rows="6"
              placeholder="پاسخ را وارد کنید"
              v-model="answer"
            ></textarea>
          </div>
          <div class="faq-create-actions">
            <button
              type="button"
              class="sv-btn sv-btn--ghost sv-btn--wide"
              @click="$router.go(-1)"
            >
              انصراف
            </button>
            <button
              type="submit"
              class="sv-btn sv-btn--primary sv-btn--wide"
              :disabled="!question || !answer || isSubmitting"
            >
              <span v-if="isSubmitting">در حال ثبت...</span>
              <span v-else>ثبت</span>
            </button>
          </div>
        </form>
      </template>
    </net-pa-card>
  </div>
</template>

<script>
import Panel from '../Tools/NetPa/Panel.vue'
import NetPaCard from '../Tools/NetPa/NetPaCard.vue'

export default {
  components: {
    Panel,
    NetPaCard,
  },
  data() {
    return {
      question: '',
      answer: '',
      isSubmitting: false,
      DataAxiosCreateFAQ: {
        ArryfildValue: '',
        Method: 'Post',
        Action: 'FAQ/Create',
        Token: this.$session.get('TokenNetPa'),
      },
    }
  },
  methods: {
    createFAQ() {
      if (!this.question || !this.question.trim()) {
        this.$mySweetDefaultTost('خطا', 'لطفا سوال را وارد کنید', 'warning', 2000)
        return
      }
      
      if (!this.answer || !this.answer.trim()) {
        this.$mySweetDefaultTost('خطا', 'لطفا پاسخ را وارد کنید', 'warning', 2000)
        return
      }

      this.isSubmitting = true

      const formData = new FormData()
      const userInfoNetPa = this.$session.get('UserInfoNetPa')
      const azaId = userInfoNetPa ? userInfoNetPa.wwwtblAzaId : null
      
      if (!azaId) {
        this.$mySweetDefaultTost('خطا', 'اطلاعات کاربر یافت نشد', 'error', 2000)
        this.isSubmitting = false
        return
      }
      
      formData.append('azaId', azaId)
      formData.append('question', this.question.trim())
      formData.append('answer', this.answer.trim())

      this.DataAxiosCreateFAQ.ArryfildValue = formData

      this.$PostFormData(this.DataAxiosCreateFAQ)
        .then((data) => {
          if (data.status === 'Ok' || data.success === true) {
            this.$mySweetDefault('عملیات موفق', 'پرسش و پاسخ با موفقیت ثبت شد', 'success', 2000)
            this.$router.push({ name: 'FAQManagement' })
          } else {
            this.$mySweetDefaultTost('خطا', 'خطا در ثبت پرسش و پاسخ', 'error', 2000)
          }
        })
        .catch((error) => {
          console.error('Error creating FAQ:', error)
          this.$mySweetDefaultTost('خطا', 'خطا در ثبت پرسش و پاسخ', 'error', 2000)
        })
        .finally(() => {
          this.isSubmitting = false
        })
    },
  },
}
</script>

<style scoped>
#FAQCreate {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-border-default: #dbe5eb;
  --bnp-border-subtle: #e8eef2;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-motion-fast: 180ms;
  --bnp-ease-standard: cubic-bezier(0.165, 0.84, 0.44, 1);
  --sv-control-h: 40px;
}

.faq-create-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.faq-create-field {
  display: flex;
  flex-direction: column;
  text-align: right;
}

.faq-create-label {
  display: block;
  margin-bottom: 0.4rem;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.3;
}

.faq-create-input {
  min-height: 6.5rem;
  padding: 0.7rem 0.85rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  line-height: 1.7;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  resize: vertical;
}

.faq-create-field:first-child .faq-create-input {
  min-height: 5rem;
}

.faq-create-input:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

.faq-create-input::placeholder {
  color: #8a96a3;
}

.faq-create-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 16px;
  border-top: 1px solid var(--bnp-border-subtle);
}

.sv-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: var(--sv-control-h);
  padding: 6px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  border-radius: 12px;
  cursor: pointer;
  transition:
    color var(--bnp-motion-fast) var(--bnp-ease-standard),
    background var(--bnp-motion-fast) var(--bnp-ease-standard),
    border-color var(--bnp-motion-fast) var(--bnp-ease-standard),
    box-shadow var(--bnp-motion-fast) var(--bnp-ease-standard),
    transform var(--bnp-motion-fast) var(--bnp-ease-standard);
}

.sv-btn:focus {
  outline: none;
}

.sv-btn:focus-visible {
  box-shadow: var(--bnp-focus-ring);
}

.sv-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

.sv-btn--ghost {
  color: var(--bnp-brand-navy);
  border: 1px solid var(--bnp-border-default);
  background: #fff;
}

.sv-btn--ghost:not(:disabled):hover {
  color: var(--bnp-brand-purple);
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

.sv-btn--primary {
  color: #fff;
  border: 0;
  background: linear-gradient(
    110deg,
    var(--bnp-brand-navy),
    var(--bnp-brand-indigo) 58%,
    var(--bnp-brand-purple)
  );
  box-shadow: var(--bnp-shadow-md);
}

.sv-btn--primary:not(:disabled):hover {
  color: #fff;
  transform: translateY(-1px);
}

.sv-btn--wide {
  min-width: 168px;
  min-height: 44px;
}

@media (max-width: 767px) {
  .faq-create-actions .sv-btn {
    flex: 1 1 auto;
  }
}

@media (prefers-reduced-motion: reduce) {
  .sv-btn {
    transition: none;
  }

  .sv-btn--primary:not(:disabled):hover {
    transform: none;
  }
}
</style>

